
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";

const EMPLOYER_HCV_SERVICE_REQUEST_ALIAS = "employer_hcv";

const SERVICE = {
  id: 1,
  alias: EMPLOYER_HCV_SERVICE_REQUEST_ALIAS,
  paragraph_1:
    "A Health and Care Worker visa allows medical professionals to work for the NHS, an NHS supplier, or in an adult social care facility. ",
  benefitsTitle: "If you want to hire medical professionals through this route, we will:",
  benefits: [
    "Prepare visa application, collect all required documents and draft\n" + "a cover letter",
    "Represent your candidate in front of the Home Office during the visa\n" + " process",
    "Provide on-call immigration expert support",
    "Take care of all activities necessary for the visa application to be successful",
    "Communicate with the Home Office",
  ],
  feeTitle: "For a fixed fee",
  fee: 800,
  feeDescription: "+ VAT (not including the Home Office fees)",
};

const INITIAL_SERVICE_REQUEST_OPTION = 1;

@Component
export default class WidgetHealthCareVisa extends Vue {
  service = SERVICE;

  popup = false;

  selectedOption = INITIAL_SERVICE_REQUEST_OPTION;

  openPopup() {
    this.$emit("start");

    this.popup = true;
  }

  closePopup() {
    this.popup = false;
  }

  // NOTE: If services number will be more then 1, use implementation like in "WidgetSkilledWorkerVisa" component;
  getServiceAlias() {
    const item = this.service;

    if (!item) return null;

    return item.alias;
  }

  async submitRequest() {
    const alias = this.getServiceAlias();

    if (!alias) return;

    try {
      await this.axios.get(API_ROUTES.SERVICE_REQUEST(alias));

      this.$emit("on-submit");
    } finally {
      this.closePopup();
    }
  }
}
